/* ============================================================
   PILLAR QUIZ DIFFUSEURS — Quel diffuseur est fait pour vous ?
   4 questions · scoring 4 issues
     us-salon  : Ultrasonique salon (volume + brume + LED)
     us-cham   : Ultrasonique chambre (compact + veilleuse douce)
     cd-bureau : Chaleur douce bureau (silencieux + design + sans eau)
     he-encens : Huiles d'encens boisées (Oud, santal, bois sacré asiatique)
   ============================================================ */

(function () {
  'use strict';

  var ICONS = {
    'us-salon': '<svg viewBox="0 0 40 44" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 C 14 13, 13 22, 16 28 Q 18 32, 20 32 Q 22 32, 24 28 C 27 22, 26 13, 20 6 Z"/><path d="M8 38 Q 14 35, 20 38 Q 26 35, 32 38" opacity="0.5"/><path d="M5 41 Q 13 37, 20 41 Q 27 37, 35 41" opacity="0.35"/></svg>',
    'us-cham': '<svg viewBox="0 0 40 44" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="20" cy="24" r="10"/><path d="M20 17 Q 17 13, 20 9 Q 23 13, 20 17 Z" opacity="0.7"/><circle cx="14" cy="32" r="0.8" fill="currentColor" stroke="none" opacity="0.4"/><circle cx="26" cy="32" r="0.8" fill="currentColor" stroke="none" opacity="0.4"/><path d="M9 6 L 11 8 M14 4 L 15 6 M20 3 L 20 5 M26 4 L 25 6 M31 6 L 29 8" opacity="0.55"/></svg>',
    'cd-bureau': '<svg viewBox="0 0 40 44" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 36 C 13 33, 10 26, 13 18 Q 16 21, 19 19 C 17 12, 22 5, 25 9 Q 24 14, 27 16 C 30 21, 30 30, 25 33 Q 23 36, 20 36 Z"/><line x1="8" y1="40" x2="32" y2="40"/><path d="M12 13 Q 10 9, 13 6" opacity="0.5"/><path d="M28 13 Q 30 9, 27 6" opacity="0.5"/></svg>',
    'he-encens': '<svg viewBox="0 0 40 44" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M16 20 L 16 32 Q 16 36, 20 36 Q 24 36, 24 32 L 24 20 Z"/><rect x="14" y="14" width="12" height="6" rx="1"/><rect x="17" y="9" width="6" height="5" rx="1"/><path d="M14 6 Q 12 4, 14 1" opacity="0.55"/><path d="M26 6 Q 28 4, 26 1" opacity="0.55"/><circle cx="11" cy="9" r="0.7" fill="currentColor" stroke="none" opacity="0.5"/><circle cx="29" cy="10" r="0.7" fill="currentColor" stroke="none" opacity="0.5"/></svg>'
  };

  var QUIZ_DATA = window.QUIZ_DATA_DIF;

  function initQuiz(root) {
    var engine = root.querySelector('[data-pq-engine]');
    if (!engine) return;

    var stateIntro = engine.querySelector('[data-pq-state="intro"]');
    var stateQuestion = engine.querySelector('[data-pq-state="question"]');
    var stateResult = engine.querySelector('[data-pq-state="result"]');
    var startBtn = engine.querySelector('[data-pq-start]');
    var backBtn = engine.querySelector('[data-pq-back]');
    var restartBtn = engine.querySelector('[data-pq-restart]');
    var qTitle = engine.querySelector('[data-pq-question]');
    var qOptions = engine.querySelector('[data-pq-options]');
    var pCurrent = engine.querySelector('[data-pq-progress-current]');
    var pTotal = engine.querySelector('[data-pq-progress-total]');
    var pFill = engine.querySelector('[data-pq-progress-fill]');
    var rIcon = engine.querySelector('[data-pq-result-icon]');
    var rTitle = engine.querySelector('[data-pq-result-title]');
    var rText = engine.querySelector('[data-pq-result-text]');
    var rMain = engine.querySelector('[data-pq-result-cta-main]');
    var rMainLabel = engine.querySelector('[data-pq-result-cta-main-label]');
    var rUpsell = engine.querySelector('[data-pq-result-cta-upsell]');
    var rUpsellLabel = engine.querySelector('[data-pq-result-cta-upsell-label]');

    var state = {
      qIndex: 0,
      scores: { 'us-salon': 0, 'us-cham': 0, 'cd-bureau': 0, 'he-encens': 0 },
      history: []
    };

    pTotal.textContent = QUIZ_DATA.questions.length;

    function show(stateEl) {
      [stateIntro, stateQuestion, stateResult].forEach(function (s) { s.hidden = (s !== stateEl); });
      stateEl.classList.remove('is-fading-in');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          stateEl.classList.add('is-fading-in');
        });
      });
    }

    function scrollIntoView() {
      var rect = root.getBoundingClientRect();
      var stickyHeader = document.querySelector('sticky-header');
      var headerOffset = stickyHeader ? stickyHeader.offsetHeight + 16 : 80;
      if (rect.top < headerOffset || rect.top > window.innerHeight * 0.4) {
        var targetY = rect.top + window.pageYOffset - headerOffset;
        window.scrollTo({ top: targetY, behavior: 'smooth' });
      }
    }

    function renderQuestion() {
      var q = QUIZ_DATA.questions[state.qIndex];
      qTitle.textContent = q.text;
      pCurrent.textContent = (state.qIndex + 1);
      var pct = ((state.qIndex + 1) / QUIZ_DATA.questions.length) * 100;
      pFill.style.width = pct + '%';
      qOptions.innerHTML = '';
      q.options.forEach(function (opt, idx) {
        var li = document.createElement('li');
        li.className = 'pq-options__item';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pq-option';
        btn.innerHTML = '<span class="pq-option__dot" aria-hidden="true"></span><span class="pq-option__label">' + opt.label + '</span>';
        btn.addEventListener('click', function () { onAnswer(idx); });
        li.appendChild(btn);
        qOptions.appendChild(li);
      });
      backBtn.hidden = (state.qIndex === 0);
      show(stateQuestion);
    }

    function onAnswer(optIdx) {
      var q = QUIZ_DATA.questions[state.qIndex];
      var opt = q.options[optIdx];
      state.history.push({ qIndex: state.qIndex, scores: Object.assign({}, opt.scores) });
      Object.keys(opt.scores).forEach(function (k) {
        state.scores[k] = (state.scores[k] || 0) + opt.scores[k];
      });
      if (state.qIndex < QUIZ_DATA.questions.length - 1) {
        state.qIndex++;
        renderQuestion();
      } else {
        renderResult();
      }
    }

    function onBack() {
      if (state.qIndex === 0 || state.history.length === 0) return;
      var last = state.history.pop();
      Object.keys(last.scores).forEach(function (k) {
        state.scores[k] = (state.scores[k] || 0) - last.scores[k];
      });
      state.qIndex--;
      renderQuestion();
    }

    function pickWinner() {
      var keys = Object.keys(state.scores);
      var winner = keys[0];
      var max = -Infinity;
      keys.forEach(function (k) {
        if (state.scores[k] > max) { max = state.scores[k]; winner = k; }
      });
      return winner;
    }

    function renderResult() {
      var winner = pickWinner();
      var r = QUIZ_DATA.results[winner];
      if (rIcon) {
        rIcon.innerHTML = ICONS[winner] || '';
        rIcon.setAttribute('data-pq-icon-key', winner);
      }
      rTitle.textContent = r.title;
      rText.textContent = r.text;
      rMainLabel.textContent = r.ctaMain.label;
      rMain.setAttribute('href', r.ctaMain.url);
      rUpsellLabel.textContent = r.ctaUpsell.label;
      rUpsell.setAttribute('href', r.ctaUpsell.url);
      try {
        if (window.dataLayer) {
          window.dataLayer.push({ event: 'pillar_quiz_diffuseurs_result', quiz_winner: winner });
        }
        if (window.gtag) { window.gtag('event', 'pillar_quiz_diffuseurs_result', { quiz_winner: winner }); }
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
          window.Shopify.analytics.publish('pillar_quiz_diffuseurs_result', { quiz_winner: winner });
        }
      } catch (e) {}
      show(stateResult);
    }

    function onRestart() {
      state.qIndex = 0;
      state.scores = { 'us-salon': 0, 'us-cham': 0, 'cd-bureau': 0, 'he-encens': 0 };
      state.history = [];
      show(stateIntro);
      scrollIntoView();
    }

    startBtn.addEventListener('click', function () {
      try {
        if (window.dataLayer) window.dataLayer.push({ event: 'pillar_quiz_diffuseurs_start' });
        if (window.gtag) window.gtag('event', 'pillar_quiz_diffuseurs_start');
      } catch (e) {}
      renderQuestion();
      scrollIntoView();
    });

    backBtn.addEventListener('click', onBack);
    restartBtn.addEventListener('click', onRestart);

    show(stateIntro);
  }

  function bootAll() {
    document.querySelectorAll('.pq-section--diffuseurs').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
})();
